import "./App.css";
import AppRoutes from "./AppRoutes";

const App = () => {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
};

export default App;
